import { Model } from './Model';
import { FeatureFlagModel, IFeatureFlagModel } from './FeatureFlagModel';
import { IUserModel } from './UserModel';

export interface IUserFeatureFlagModel extends Model {
  userFeatureFlagId: number;
  userId: number;
  featureFlagId: number;
  startDate: string | undefined;
  endDate: string | undefined;
  enabled: boolean;
  featureFlag: IFeatureFlagModel;
}

export class UserFeatureFlagModel
  extends Model
  implements IUserFeatureFlagModel
{
  userFeatureFlagId: number;
  userId: number;
  featureFlagId: number;
  startDate: string | undefined;
  endDate: string | undefined;
  enabled: boolean;
  featureFlag: FeatureFlagModel;

  constructor(params: Partial<IUserFeatureFlagModel>) {
    super(params);

    const {
      userFeatureFlagId = 0,
      userId = 0,
      featureFlagId = 0,
      startDate = undefined,
      endDate = undefined,
      enabled = false,
      featureFlag = {},
    } = params;

    this.userFeatureFlagId = userFeatureFlagId;
    this.userId = userId;
    this.featureFlagId = featureFlagId;
    this.startDate = startDate;
    this.endDate = endDate;
    this.enabled = enabled;
    this.featureFlag = featureFlag && new FeatureFlagModel(featureFlag);
  }

  static GetUserFeatureFlag = (
    user: IUserModel,
    featureFlag: FeatureFlagModel,
  ) => {
    return new UserFeatureFlagModel({
      userFeatureFlagId: 0,
      userId: user.userId,
      featureFlagId: featureFlag.featureFlagId,
      startDate: undefined,
      endDate: undefined,
      enabled: true,
      featureFlag: featureFlag,
      rowVersion: featureFlag.rowVersion,
    });
  };
}
